module.exports = "/_next/static/images/west-virginia-2c8ccff686316bbffdaa4fd3c4dea2bd.svg";